"use client";

import React from "react";
import { TableCell, TableRow } from "./ui/table";
import { transactionCategoryStyles } from "@/constants";
import { cn } from "@/lib/utils";
import Link from "next/link";

const CategoryBadge = ({ category, label }: CategoryBadgeProps) => {
  const { borderColor, backgroundColor, textColor, chipBackgroundColor } =
    transactionCategoryStyles[
      category as keyof typeof transactionCategoryStyles
    ] || transactionCategoryStyles.default;

  return (
    <div className={cn("category-badge", borderColor, chipBackgroundColor)}>
      <div className={cn("size-2 rounded-full", backgroundColor)} />
      <p className={cn("text-[12px] font-medium", textColor)}>{label}</p>
    </div>
  );
};

const EventRow = ({
  user,
  event,
  displayAll
}:{
  user: User|null;
  event: Eventi;
  displayAll:boolean;
}) => {
console.log("EventRow", event);
  //to be removed
  const isDebit = true; //= t.type === 'debit';

  let price_text = "";
  let commission_text = "";

  if (event.startingPrice) {
    price_text = `${event.startingPrice.toFixed(0)} €`;

    if (
      event.event_commission_total &&
      event.event_commission_total > event.startingPrice
    ) {
      price_text = `${event.startingPrice.toFixed(0)} - ${event.event_commission_total.toFixed(0)} €`;
    }
  }

  if (event.event_commission_intermediary) {
    if (event.startingPrice) {
      commission_text = `${(event.event_commission_intermediary * event.startingPrice).toFixed(0)} €`;
    }

    if (
      event.event_commission_total &&
      event.event_commission_total > event.startingPrice
    ) {
      commission_text = `${(event.event_commission_intermediary * event.startingPrice).toFixed(0)} - ${(event.event_commission_intermediary * event.event_commission_total).toFixed(0)} €`;
    }
  }

  return (
    <TableRow
      key={event.eventId}
      className={`${
        !isDebit ? "bg-[#FFFBFA]" : "bg-[#F6FEF9]"
      } !over:bg-none !border-b-DEFAULT`}
    >

      <TableCell className="max-w-[250px] pl-2 pr-4">
        <div className="flex flex-col gap-1">
          <h1 className="text-14 text-left font-semibold text-[#344054]">
            {event.name}
          </h1>
          
        </div>
      </TableCell>

      <TableCell className="max-w-[250px] pl-2 pr-4">
        <div className="flex flex-col items-center gap-1 text-wrap">
          <h1 className="text-14  font-semibold text-[#344054]">
            {price_text} {event.event_pricing_comment ? ' *' : ""}
          </h1>
        </div>
      </TableCell>

      {displayAll && (
              <TableCell className="max-w-[250px] pl-2 pr-4">
              <div className="flex flex-col items-center gap-1 text-wrap">
                <h1 className="text-14  font-semibold text-[#344054]">
                  {commission_text}
                </h1>
              </div>
            </TableCell>
      )}

    <TableCell className="min-w-32 pl-2 pr-4 max-w-[250px]">
        <div>
            <Link target="_blank" href={`https://labelleconciergerie.com/event/${event.eventId}?localparam=${user?.user_token}`} className={cn("text-[12px] font-bold", "text-[#027A48]")}>
            <CategoryBadge
            category=" SUCCESS"
            label="Cliquez pour commander ces tickets"/></Link>
            {event.event_pricing_comment && (<div className="italic text-xs mt-1">* {event.event_pricing_comment}</div>)}
        </div>
      </TableCell>
      
    </TableRow>
  );
};

export default EventRow;
